// extracted by mini-css-extract-plugin
export default {"container":"Modal-module--container--3nXi0","video":"Modal-module--video--3QqSr","button":"Modal-module--button--3qUqn","buttonClose":"Modal-module--buttonClose--3Hg8i"};